import { Card, Flex, styled } from '@grupoboticario/flora-react';

const styles = {
  Wrapper: styled('div', {
    '@tablet': {
      gridColumn: '3 / span 1',
    },
  }),

  PaymentInfo: styled(Card, {
    borderRadius: '$small',
    flexDirection: 'column',
    gap: '$2',
    padding: '$4',
  }),

  PaymentName: styled(Flex, {
    textAlign: 'right',
  }),
};

export default styles;
